/* eslint key-spacing: 'off', comma-spacing: 'off' */
import current from '@/scripts/current'
import navigation from '@/scripts/crossTabulation/navigation'

export default {
    type: '/crossTabulation',
    getNextPage: function (currentStep) {
        var step = navigation.getStep(currentStep);
        var stepIndex = navigation.stepIndex[step];
        if (step === 'columnvariable')
            return current.selectionModel.v.column.include ? navigation.page.controlvariables : navigation.page.statistics;
        return navigation.getPage(stepIndex, stepIndex + 1);
    },
    getPreviousPage: function (currentStep) {
        var step = navigation.getStep(currentStep);
        var stepIndex = navigation.stepIndex[step];
        if (step === 'controlvariables' || (step === 'statistics' && !current.selectionModel.v.column.include))
            return navigation.page.columnvariable;
        return navigation.getPage(stepIndex, stepIndex - 1);
    },
    getPage: function (stepIndex, nextStepIndex) {
        return nextStepIndex > navigation.keys.length || nextStepIndex < 0 ? navigation.page[navigation.keys[stepIndex]]
            : navigation.page[navigation.keys[nextStepIndex]];
    },
    getStep: function (currentStep) {
        return currentStep === undefined || currentStep === null ? current.selectionModel.currentStep : currentStep;
    },
    initialize: function () {
        navigation.keys = Object.keys(navigation.page);
        navigation.keys.forEach((k, i) => {
            navigation.stepIndex[k] = i;
            navigation.step[k] = k;
        });
    },
    keys: null,
    stepIndex: {
        //root: 0,
        //years: 1,
        //...
    },
    page: {
        root: '/',
        years: '/crossTabulation/selectYear',
        location: '/crossTabulation/selectLocation',
        rowvariable: '/crossTabulation/selectRowVariable',
        columnvariable: '/crossTabulation/selectColumnVariable',
        controlvariables: '/crossTabulation/selectControlVariables',
        statistics: '/crossTabulation/selectStatistics',
        viewreport: '/crossTabulation/viewReport'
    },
    titles: {
        root: '/',
        years: 'Cross Tabulation Years',
        location: 'Location',
        rowvariable: 'Row',
        columnvariable: 'Column',
        controlvariables: 'Controls',
        statistics: 'Statistics',
        viewreport: 'Report'
    },
    //   navItems: {
    //     root: '/',
    //     years: '/crossTabulation/selectYear',
    //     location: '/crossTabulation/selectLocation',
    //     rowvariable: '/crossTabulation/selectRowVariable',
    //     columnvariable: '/crossTabulation/selectColumnVariable',
    //     controlvariables: '/crossTabulation/selectControlVariables',
    //     statistics: '/crossTabulation/selectStatistics',
    //     viewreport: '/crossTabulation/viewReport'
    //   },
    routeNames: {
        root: '/',
        years: 'crossTabulationSelectYear',
        location: 'crossTabulationSelectLocation',
        rowvariable: 'crossTabulationSelectRowVariable',
        columnvariable: 'crossTabulationSelectColumnVariable',
        controlvariables: 'crossTabulationSelectControlVariables',
        statistics: 'crossTabulationSelectStatistics',
        viewreport: 'crossTabulationViewReport'
    },
    step: {
        //years: 'years',
        //location: 'location',
        //...
    }
}
